const STORAGE_KEY = 'shmatch:landing:cookie-consent';

export type CookieConsentChoice = 'accepted' | 'rejected';

export function hasCookieConsent(): boolean {
  if (typeof window === 'undefined') return true;
  const value = window.localStorage.getItem(STORAGE_KEY);
  return value === 'accepted' || value === 'rejected';
}

export function setCookieConsent(choice: CookieConsentChoice): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    /* ignore */
  }
}
